exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".search-filter-subdealer{margin-right:20px}@media only screen and (max-width: 1920px){.search-filter-subdealer{max-width:270px !important}}\n", ""]);

// exports
